<template src='./stepProgress.pug' lang='pug'></template>

<script>
export default {
  name: 'StepProgress',

  props: {
    steps: {
      type: Array,
      default () {
        return []
      },
      validator (val) {
        return val && val.length > 0
      }
    },
    currentStep: {
      type: Number,
      default: 0
    },
    iconClass: {
      type: String,
      default: 'fa fa-check'
    },
    activeColor: {
      type: String,
      default: '#40b9bb'
    },
    passiveColor: {
      type: String,
      default: '#b5b5b5'
    },
    activeThickness: {
      type: Number,
      default: 10
    },
    passiveThickness: {
      type: Number,
      default: 3
    },
    lineThickness: {
      type: Number,
      default: 4
    }
  },

  computed: {
    scaleX () {
      let step = this.currentStep
      if (step < 0) {
        step = 0
      } else if (step >= this.steps.length) {
        step = this.steps.length - 1
      }
      return step / (this.steps.length - 1)
    }
  }
}
</script>

<style lang="sass" scoped>
.step-progress
  &__wrapper
    width: 60%
    margin: 0 auto
    position: relative
  &__wrapper-before
    content: ''
    position: absolute
    left: 0
    top: 50%
    height: 12px
    width: 100%
    background-color: #b5b5b5
    transform: translateY(-50%) perspective(1000px)
  &__wrapper-after
    content: ''
    position: absolute
    left: 0
    top: 50%
    height: 12px
    width: 100%
    background-color: #40b9bb
    transform: scaleX(0) translateY(-50%) perspective(1000px)
    transform-origin: left center
    transition: transform .5s ease
  &__bar
    width: 100%
    display: flex
    height: 100px
    justify-content: space-between
    align-items: center
    margin-bottom: 25px
  &__step
    z-index: 2
    position: relative
    --activeColor: #40b9bb
    --passiveColor: #b5b5b5
    --activeBorder: 5px
    --passiveBorder: 5px
    &--active
      span
        color: var(--activeColor)
      .step-progress__step-label
        color: var(--activeColor)
      .step-progress__step-icon
        opacity: 1
    &--valid
      .step-progress__step-icon
        opacity: 1
        transform: translate3d(-50%, -50%, 0) scale(1) perspective(1000px)
      .step-progress__step-label
        color: var(--activeColor)
    &:after
      content: ""
      position: absolute
      z-index: -1
      left: 50%
      top: 50%
      transform: translate(-50%, -50%) perspective(1000px)
      width: 30px
      height: 30px
      background-color: #fff
      border-radius: 50%
      border: var(--passiveBorder) solid var(--passiveColor)
      transition: .3s ease
      @media (max-width: 767px)
        width: 40px
        height: 40px
    &--active:after
      border: var(--activeBorder) solid var(--activeColor)
    &--valid:after
      background-color: var(--activeColor)
      border: var(--activeBorder) solid var(--activeColor)
  &__step-label
    position: absolute
    top: calc(100% + 25px)
    left: 50%
    transform: translateX(-50%) perspective(1000px)
    white-space: nowrap
    font-weight: 600
    color: #b5b5b5
    transition: .3s ease
  &__step-icon
    color: #fff
    position: absolute
    left: 50%
    top: 50%
    transition: transform .3s ease
    opacity: 0
    transform: translate3d(-50%, -50%, 0) scale(0) perspective(1000px)
    @media (max-width: 767px)
      font-size: 22px
</style>



// WEBPACK FOOTER //
// StepProgress.vue?dfc0a1c6